import { ChangeEvent, FocusEvent } from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { ITextInputProps, TextInput } from './TextInput';

type Value = ITextInputProps['value'];
type ITextInputFieldProps = ITextInputProps & FieldProps<Value, FieldRenderProps<Value>>;

export const TextInputField = (props: ITextInputFieldProps) => {
  const {
    afterSubmit,
    allowNull,
    beforeSubmit,
    data,
    defaultValue,
    format,
    formatOnBlur,
    initialValue,
    isEqual,
    multiple,
    name,
    parse,
    subscription,
    type,
    validate,
    validateFields,
    value,
    ...componentProps
  } = props;
  return (
    <Field
      afterSubmit={afterSubmit}
      allowNull={allowNull}
      beforeSubmit={beforeSubmit}
      data={data}
      defaultValue={defaultValue}
      format={format}
      formatOnBlur={formatOnBlur}
      initialValue={initialValue}
      isEqual={isEqual}
      multiple={multiple}
      name={name}
      parse={parse}
      subscription={subscription}
      type={type}
      validate={validate}
      validateFields={validateFields}
      value={value}
    >
      {({ input, meta }) => {
        const { onBlur, onChange, onFocus, ...restComponentProps } = componentProps;
        const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
          input.onBlur(e);
          if (onBlur) {
            onBlur(e);
          }
        };
        const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
          input.onChange(e);
          if (onChange) {
            onChange(e);
          }
        };
        const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
          input.onFocus(e);
          if (onFocus) {
            onFocus(e);
          }
        };
        const error =
          (meta.touched && restComponentProps.error) || (meta.touched && meta.error) ? meta.error : undefined;
        const errorOnSubmit = meta.error && (meta.dirty || meta.submitFailed) && meta.touched && meta.error;
        return (
          <TextInput
            {...restComponentProps}
            {...input}
            error={restComponentProps.validateOnSubmit ? errorOnSubmit : error}
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          />
        );
      }}
    </Field>
  );
};
